<template>
  <w-sliding-popup ref="slidingPopup" title="장애티켓 등록" width="950px" @close="close">
    <div slot="content">
      <el-row class="title-bar mr-t10" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <div class="title-h4">이벤트 정보</div>
        </div>
        <w-recommend-handling-trouble-button :event-hist-seq-numbers="eventHistSeqNumbers"></w-recommend-handling-trouble-button>
      </el-row>
      <el-table-wrapper ref="eventInfoList" :column-default="columnDefault" :data="targetRowArray" :columns="eventStatusColumns" header-align="center" @current-change="changeSelectionEvent" :pagination="false" style="width:100%;" border highlight-current-row>
        <template slot-scope="scope" slot="eventlevel-slot">
          <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
        </template>
      </el-table-wrapper>

      <div class="mr-t25 title-h4">장애티켓 등록 정보</div>
      <el-form :model="formData" ref="formData" style="width: 100%" class="el-form-ticket-select-class" :rules="rules">
        <el-row type="flex" :gutter="10">
          <el-col :span="6">
            <el-form-item label="긴급도">
              <el-select style="width: 100%;" @change="changeSelectUrgency" v-model="formData.troubleUrgency">
                <el-option v-for="item in urgencyData" :key="item.orderbyIndex" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="영향도">
              <el-select style="width: 100%;" @change="changeSelectImpact" v-model="formData.troubleImpact">
                <el-option v-for="item in impactData" :key="item.orderbyIndex" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="장애티켓 제목" prop="subject">
              <el-input style="width: 100%;" v-model="formData.subject" placeholder="제목을 입력하여 주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="티켓 발행 내용">
          <el-input placeholder="티켓 발행 내용은 처리 이력에 등록됩니다." type="textarea" :rows="10"
          v-model="formData.comment" class="ticket-input-class"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="troubleShootingBtn">티켓 발행</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import { isNil, forEach, isEmpty } from 'lodash';
import TroubleShootingAPI from '@/api/event/trouble-shooting';
import msgUtil from '@/utils/message';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import WEventlevelCell from '@/components/table/EventlevelCell';
import { columnDefault } from '@/constants/table';
import WRecommendHandlingTroubleButton from '../RecommendHandlingTroubleButton';

export default {
  name: 'WEventTicketAddPopup',
  components: {
    WEventlevelCell,
    WRecommendHandlingTroubleButton,
  },
  props: {
    targetRowArray: {
      type: Array,
    },
    activeTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      eventData: {},
      rules: {
        subject: { required: true, trigger: 'blur', message: '장애티켓 제목을 입력해주세요' },
      },
      eventStatusColumns: [
        { prop: 'eventlevelName', label: '등급', width: 80, scopedSlot: 'eventlevel-slot', className: 'eventlevel', columnKey: 'eventlevelId' },
        { prop: 'managetypeName', label: '관리구분', width: 80 },
        { prop: 'objName', label: '대상', width: 170, formatter: this.getTargetInfo },
        { prop: 'rsctypeName', label: '자원구분', width: 135 },
        { prop: 'eventMessage', label: '장애메시지' },
        { prop: 'checkDatetime', label: '최초발생시각', width: 135, formatter: this.getDateFormatter },
      ],
      formData: {
        subject: '',
        troubleUrgency: '',
        troubleImpact: '',
        comment: '',
        eventSeqNumber: [],
      },
      seqValidFlag: false,
    };
  },
  computed: {
    eventHistSeqNumbers() {
      const seqNumber = [];
      if (!isEmpty(this.targetRowArray)) {
        this.targetRowArray.forEach((item) => {
          if (!isNil(item.eventSeqNumber)) {
            seqNumber.push(item.eventSeqNumber);
          } else {
            seqNumber.push(item.seqNumber);
          }
        });
      }
      return seqNumber;
    },
    ...mapGetters(['urgencyData', 'impactData']),
  },
  watch: {
    // targetRowArray: {
    //   handler(value) {
    //     if (!isEmpty(value)) {
    //       this.$nextTick(() => {
    //         this.targetRowArray.forEach((item) => {
    //           this.eventHistSeqNumbers.push(item.eventSeqNumber);
    //         });
    //       });
    //       // this.$refs.eventInfoList.$children[0].setCurrentRow(value[0]);
    //       // this.changeSelectionEvent(value[0]);
    //       // this.changeSelectionEvent(value[0]);
    //     }
    //   },
    //   immediate: true,
    // },
  },
  methods: {
    closePopup() {
      this.close();
      this.$refs.slidingPopup.close();
    },
    close() {
      this.$emit('close-add-popup');
      this.$refs.formData.resetFields();
      this.eventData = null;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.seqValidFlag = false;
        this.formData = {
          subject: '',
          troubleUrgency: this.urgencyData[this.urgencyData.length - 1].basicinfoSubid,
          troubleImpact: this.impactData[this.impactData.length - 1].basicinfoSubid,
          comment: '',
          eventSeqNumbers: [],
        }; // formData 초기화
      });
    },
    /**
     * 대상 정보를 반환한다.
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getTargetInfo(row, column, value) {
      if (row.objDefineId !== 'SERVICE' || row.objDefineId !== 'E2E_SERVICE' || row.objDefineId !== 'FMS_SENSOR') {
        return `${getValueAfterCheckEmpty(value)} (${getValueAfterCheckEmpty(row.ipaddress)})`;
      }
      return getValueAfterCheckEmpty(value);
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    changeSelectUrgency(value) {
      this.formData.troubleUrgency = value;
    },
    changeSelectImpact(value) {
      this.formData.troubleImpact = value;
    },
    // 티켓발행 클릭
    troubleShootingBtn() {
      this.$refs.formData.validate().then((valiResponse) => {
        if (valiResponse) {
          const targetData = this.formData;
          targetData.objInfoList = this.targetRowArray;
          const objInfoList = [];
          forEach(this.targetRowArray, (item) => {
            objInfoList.push(item.objId);
          });
          targetData.objInfoList = objInfoList;

          // 체크한 장애 대상들의 eventSeqNumber, seqNumber만을 배열에 담아 보낸다.
          for (let i = 0; i < this.targetRowArray.length; i += 1) {
            if (this.activeTab === 'event-status') {
              // status일 경우 eventSeqNumber
              targetData.eventSeqNumbers.push(this.targetRowArray[i].eventSeqNumber);
            } else {
              // 이력일 경우 seqNumber
              targetData.eventSeqNumbers.push(this.targetRowArray[i].seqNumber);
            }
          }
          forEach(targetData.eventSeqNumbers, (item) => {
            if (isNil(item)) {
              this.seqValidFlag = true;
            }
          });
          const target = '장애티켓';
          const action = '발행';
          if (!this.seqValidFlag) {
            // troubleShooting 발행
            TroubleShootingAPI.setTroubleShooting(targetData).then((response) => {
              if (response.data.success) {
                // EventTicketAddPop에서 전파할 이벤트로 장애티켓을 발행했다면 해당 이벤트 현황 혹은 이력현황을 reload해야한다.
                this.$emit('load-data');
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.closePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          } else {
            this.$message(msgUtil.getCustomResultMsgData('티켓이 발행되지 않은 이벤트가 존재합니다.', false));
            this.closePopup();
          }
        }
      }).catch(() => {});
    },
    changeSelectionEvent(value) {
      this.eventData = value;
    },
  },
};
</script>

<!-- 임시코드로, 추후 삭제 요망 -->
<style>
.ticket-input-class .el-textarea__inner {
  background: #f0f2f4;
}
.el-form-ticket-select-class .el-input {
  margin-top: 10px;
}
</style>

<style scoped>
.title-table {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/event/components/popup/EventTicketAddPopup.vue